import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface SessionState {
  banner: {
    isShowHolidayBanner: boolean;
  };
}

const initialState: SessionState = {
  banner: {
    isShowHolidayBanner: true,
  },
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    handleBanner: (state, action: PayloadAction<{ key: keyof (typeof initialState)['banner']; value: boolean }>) => {
      state.banner[action.payload.key] = action.payload.value;
    },
  },
});

export const isShowBannerSelector = createSelector(
  (state: RootState) => state.session,
  (state) => state.banner,
);

export default sessionSlice;
